import { visuallyHidden } from "../../styles/utils.css";
import { elementLabelStyles } from "./ElementTypeLabel.css";
import { ElementTypeLabelProps } from "./types";

const ElementTypeLabel = ({ elementType }: ElementTypeLabelProps) => (
  <div className={elementLabelStyles}>
    <span className={visuallyHidden}>{elementType.singular_name}</span>
    <span aria-hidden="true">{elementType.singular_name_short}</span>
  </div>
);

export default ElementTypeLabel;
